// extracted by mini-css-extract-plugin
export default {"modal_header":"customModal_modal_header__QP+Xo","close_btn":"customModal_close_btn__UP5tu","title":"customModal_title__CoQFg"};